"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateItemPrototype = validateItemPrototype;
const validation_1 = require("../validation");
const definitions_1 = require("./definitions");
function validateItemPrototype(item, context) {
    const itemDefinition = definitions_1.ITEMS[item.type];
    if (!itemDefinition) {
        throw new validation_1.ValidationError.MissingDefinition(`Missing definition for ${item.type}. Update may be required.`);
    }
    // const validatorStr = `\n${itemDefinition.configurationValidator.toString()}`;
    // console.debug(
    //   `Validating ItemPrototype`,
    //   item,
    //   validatorStr.replaceAll("\n", "\n    ")
    // );
    return itemDefinition.configurationValidator.validate({
        name: item.name,
        type: item.type,
        config: item.defaults,
        customScript: item.customScript,
        required: item.required,
        isCompletionAction: item.isCompletionAction,
        position: item.position,
    }, context);
}
//# sourceMappingURL=ItemValidator.js.map